import React from 'react';
import styles from './ControlBlock.module.css';

export const controlTypes = ['repeat', 'if', 'elseif', 'else'] as const;
export type ControlType = (typeof controlTypes)[number];

interface ControlBlockProps {
  type: ControlType;
  condition?: React.ReactNode;
  color: string;
  children: React.ReactNode;
  indent?: number;
}

export function isControlType(value: string | undefined): value is ControlType {
  if (value === undefined) return false;
  return (controlTypes as readonly string[]).includes(value);
}

export const ControlBlock: React.FC<ControlBlockProps> = ({ condition, color, children, indent = 0 }) => {
  return (
    <div className={styles.controlBlockContainer} style={{ marginLeft: `${indent * 20}px` }}>
      <div className={styles.controlHeader} style={{ backgroundColor: color }}>
        {condition && <span className={styles.condition}>{condition}</span>}
      </div>
      <div className={styles.controlBody} style={{ borderLeftColor: color }}>
        {children}
      </div>
      <div className={styles.controlFooter} style={{ backgroundColor: color }}></div>
    </div>
  );
};
